import './App.css';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { NavigationBar } from './components/NavigationBar/NavigationBar';
import SpinnerComponent from './components/Spinner/SpinnerComponent';
import Home from './pages/Home/Home';
import Nosotros from './pages/Nosotros/Nosotros';
import Contacto from './pages/Contacto/Contacto';
import Productos from './pages/Productos/Productos';
import ProductoDetalle from './components/ProductoDetalle/ProductoDetalle';
import WhatsApp from './components/WhatsApp/WhatsApp';

function AppContent() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return (
    <>
      <NavigationBar />
      <WhatsApp />
      {loading ? (
        <div className="spinner-container">
          <SpinnerComponent />
        </div>
      ) : (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/productos" element={<Productos />} />
          <Route path="/productos/:id" element={<Productos />} />
          <Route path="/producto/:id" element={<ProductoDetalle />} />
        </Routes>
      )}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
